import React from "react";
import { default as MUITableBody } from "@mui/material/TableBody";
import styled from "styled-components";

const StyledMUITableBody = styled(MUITableBody)``;

export const TableBody = (props) => {
  return <StyledMUITableBody {...props} />;
};
